var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `ColumnDirective` represent a column of the react Grid.
 * It must be contained in a Grid component(`GridComponent`).
 * ```tsx
 * <GridComponent dataSource={data} allowPaging={true} allowSorting={true}>
 * <ColumnsDirective>
 * <ColumnDirective field='ID' width='100'></ColumnDirective>
 * <ColumnDirective field='name' headerText='Name' width='100'></ColumnDirective>
 * <ColumnsDirective>
 * </GridComponent>
 * ```
 */

var ColumnDirective =
/** @class */
function (_super) {
  __extends(ColumnDirective, _super);

  function ColumnDirective() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ColumnDirective.moduleName = 'column';
  ColumnDirective.complexTemplate = {
    'filterItemTemplate': 'filter.itemTemplate'
  };
  return ColumnDirective;
}(ComplexBase);

export { ColumnDirective };

var ColumnsDirective =
/** @class */
function (_super) {
  __extends(ColumnsDirective, _super);

  function ColumnsDirective() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ColumnsDirective.propertyName = 'columns';
  ColumnsDirective.moduleName = 'columns';
  return ColumnsDirective;
}(ComplexBase);

export { ColumnsDirective };